<script>
// Estado padronizado de uma aba de transcrição (loading / aguardando / erro /
// vazio), com borda (FeedbackWrapper with-border, sem sombra). Cada estado tem
// ícone + cor + mensagem padrão (sobrescrevíveis via props). Quando `state` é
// 'ok' (ou vazio), renderiza o conteúdo do slot default.
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'

const STATE_DEFAULTS = {
  // aguardando processamento da IA
  processing: {
    icon: 'refresh-clock',
    color: 'warning-new',
    message: 'Processando com IA… isso pode levar alguns instantes.',
  },
  // falha — mesmo ícone do showSnack (error → close-circle / danger)
  error: {
    icon: 'close-circle',
    color: 'danger',
    message: 'Erro ao carregar. Tente novamente.',
  },
  // sem dados
  empty: {
    icon: 'warning-status',
    color: '#BEBEBE',
    message: 'Nada disponível no momento.',
  },
}

export default {
  name: 'TranscriptStateFeedback',
  components: { FeedbackWrapper },
  props: {
    // 'ok' | 'loading' | 'processing' | 'error' | 'empty'
    state: { type: String, default: 'ok' },
    message: { type: String, default: '' },
    icon: { type: String, default: '' },
    iconColor: { type: String, default: '' },
    minHeight: { type: [String, Number], default: 160 },
  },
  computed: {
    isLoading() {
      return this.state === 'loading'
    },
    isFeedback() {
      return ['processing', 'error', 'empty'].includes(this.state)
    },
    defaults() {
      return STATE_DEFAULTS[this.state] || STATE_DEFAULTS.empty
    },
    resolvedIcon() {
      return this.icon || this.defaults.icon
    },
    resolvedColor() {
      return this.iconColor || this.defaults.color
    },
    resolvedMessage() {
      return this.message || this.defaults.message
    },
  },
}
</script>

<template>
  <FeedbackWrapper
    :loading="isLoading"
    :no-data="isFeedback"
    with-border
    :icon-name="resolvedIcon"
    :icon-color="resolvedColor"
    :message="resolvedMessage"
    :min-height="minHeight"
  >
    <slot />
    <template v-if="$slots.button" v-slot:button>
      <slot name="button" />
    </template>
  </FeedbackWrapper>
</template>
